import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ItemsIssue, DialogGuiaFF6 } from 'src/app/navegacion/fulfillments/fulfillments.component';
import {HttpClient} from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { merge } from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { FormDataShipmentComponent } from './dialog-form-data-shipment.component'
import { DevolucionDatabaseItems } from '../devolucions.component';

@Component({
  selector: 'devolutions-tab-3',
  templateUrl: './devolutions-tab-3.html',
  styleUrls: ['./devolutions-tab-3.component.scss']
})
export class DevolutionsTab3 implements OnInit {

  filterName:string;

  keywords = "";

  entries: DevolucionDatabaseItems | null;

  items: ItemsIssue[] = [];

  breakpoint: number;

  columnaOne: number;
  
  columnaTwo: number;
  
  columnaThree: number;

  registerProducts = [];

  dataShipment: any = null;

  devolutionList: any = null;

  displayedColumns: string[] = ['sku', 'title', 'quantity', 'actions'];

  hasGuide = false;
  
  itemForm = new FormControl('', [
    Validators.required,
  ]);

  quantityForm = new FormControl('', [
    Validators.required,
  ]);

  checkInvRec = new FormControl('', [ ]);

  @Output() onSucess: EventEmitter<any> = new EventEmitter<any>(); 

  @Input() 
  set selectDevolution(value){
    if(value){
      this.registerProducts = value.params.body.esta_entrada.map((item, index) => {
        return {
          id: index + 1,
          index: index,
          sku: item.seller_sku,
          title: item.titulo,
          quantity: item.cantidad_anunciada,
          item_id: item.item_id,
        }
      })

      this.dataShipment = value.devolutionShipment;
      this.devolutionList = value.params.body.entrada_list;

      this.checkInvRec.setValue(this.devolutionList.inventario_rechazo);

      
    }
  };

  constructor(
    private snackBar: MatSnackBar,
    private _httpClient: HttpClient,
    private translate : TranslateService,
    public dialog: MatDialog
  ) {
    translate.setDefaultLang(localStorage.getItem('idioma'));
  }
  ngOnInit(): void {
    this.breakpoint = (window.innerWidth <= 599) ? 1 : 6;
    this.columnaOne = (window.innerWidth <= 599) ? 1 : 3;
    this.columnaTwo = (window.innerWidth <= 599) ? 1 : 2;
    this.columnaThree = (window.innerWidth <= 599) ? 1 : 1;
    this.entries = new DevolucionDatabaseItems(this._httpClient);
    this.onFilter(this.keywords); 
  }

  ngAfterViewInit() {
    this.entries = new DevolucionDatabaseItems(this._httpClient);
  }

  addTable(){
    if(this.itemForm.invalid || this.quantityForm.invalid){
      return;
    }
    const item = this.itemForm.value;
    if(!item){
      return;
    }

    if(!(typeof item === 'object' && item !== null)){
      this.snackBar.open("Debes seleccionar un producto de la lista", "OK", {                      
        duration: 5000,
      });
      return;
    }

    if(item.bundle > 0){
      this.snackBar.open("Error, no puedes agregar un bundle", "OK", {
        duration: 5000,
      });
      return;
    }
    
    let index = this.registerProducts.length + 1

    this.registerProducts = [
      ...this.registerProducts,
      ...[
        {
          id: index,
          index: index - 1,
          sku: item.seller_sku,
          title: item.title,
          quantity: this.quantityForm.value,
          item_id: item.id,
        }
      ]
    ]

    this.itemForm.setValue(null, {emitModelToViewChange: true});
    this.quantityForm.setValue(null, {emitModelToViewChange: true});
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase(); 
    this.onFilter(this.keywords);
  }

  onFilter(filterValue: string) {
    merge().pipe(
      startWith({}),
      switchMap(() => {
        return this.entries!.getRepoIssues(filterValue);
      }),
      map(data => {
        return data.items;
      }),
      catchError(() => {
        return [];
      })
    ).subscribe(data => this.items = data);
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 599) ? 1 : 6;
    this.columnaOne = (window.innerWidth <= 599) ? 1 : 3;
    this.columnaTwo = (window.innerWidth <= 599) ? 1 : 2;
    this.columnaThree = (window.innerWidth <= 599) ? 1 : 1;
  }

  displayFn(subject){

    if(!subject){
      return ""
    }

    if(subject.seller_sku){
      return `${subject.seller_sku} | Cantidad Disp. ${subject.available_quantity}`
    }else if(subject.title){
      return `${subject.title} | Cantidad Disp. ${subject.available_quantity}`
    }else {
      return ""
    }

  }

  deleteRow(row){
    this.registerProducts = this.registerProducts.filter((item) => {
      return item.index !== row.index
    })
  }

  totalProducts(){
    return this.registerProducts.reduce((acc, item) => {
      return acc + item.quantity
    }, 0)
  }

  dialogGuide(){

    if(this.registerProducts.length == 0){
      this.snackBar.open("Debe de tener por lo menos un producto", "OK", {                      
        duration: 3500,
      });
      return;
    }

    this.itemForm.setValue(null, {emitModelToViewChange: true});
    this.quantityForm.setValue(null, {emitModelToViewChange: true});

    const dialogRef = this.dialog.open(DialogGuiaFF6, {width:'450px', height: 'auto',disableClose: true})

    dialogRef.afterClosed().subscribe(result => {
      this.hasGuide = result === true ? true : false;
      const dialogRef2 = this.dialog.open(FormDataShipmentComponent ,{
        width:'50%', 
        height: 'auto',
        disableClose: true ,
        data: {
          hasGuide: this.hasGuide,
          items: this.registerProducts,
          dataShipment: this.dataShipment,
          devolutionList: this.devolutionList,
          checkInvRec: this.checkInvRec.value,
        }
      });
      dialogRef2.componentInstance.onSuccess.subscribe(() => {
        this.onSucess.emit();
        this.registerProducts = [];
      })
    });
  }

}